export default __webpack_public_path__ + "react/static/contactsFormIcon-c81da1f1a22e3f93043f7bb79ba2232d.png";